<template>
  <div class="k-page-content">
    <el-tabs v-model="activeName" class="box-eltab">
      <el-tab-pane label="用户管理" name="first">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option k-filter-input">
              <el-input placeholder="户名" v-model="searchForm.company" :size="size" disabled>
                <template slot="prepend">所属户：</template>
              </el-input>
            </div>
            <div class="k-filter-option k-filter-input">
              <el-input
                placeholder="请输入账户名称"
                v-model="searchForm.nickname"
                :size="size"
                @change="doSearch"
                clearable
              >
                <template slot="prepend">账户名称：</template>
              </el-input>
            </div>
            <div class="k-filter-option">
              <div class="k-select-area">
                <label>账号状态：</label>
                <el-select
                  v-model="searchForm.status"
                  placeholder="不限"
                  :size="size"
                  @change="doSearch"
                  clearable
                >
                  <el-option
                    v-for="item in status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <!-- <div class="k-close-icon">
                                  <i class="el-icon-close" @click="resetStatus"></i>
                </div>-->
              </div>
            </div>
          </div>
          <div class="k-common-con k-member-common">
            <div class="k-member-tree">
              <el-menu ref="menuTree" :default-active="numchecked" @select="handleNodeClick">
                <el-menu-item
                  v-for="(item, index) in treeData"
                  :key="index"
                  :index="item.id.toString()"
                >
                  <!-- <i class="el-icon-menu"></i> -->
                  <span slot="title">{{ item.label }}</span>
                </el-menu-item>
              </el-menu>
              <!-- <el-input placeholder="输入关键字进行过滤" v-model="filterText" :size="size"></el-input>
              <div style="margin-top: 10px; overflow:auto;">
                <el-tree
                  ref="tree"
                  class="filter-tree"
                  :data="treeData"
                  show-checkbox
                  node-key="id"
                  :props="defaultProps"
                  default-expand-all
                  :filter-node-method="filterNode"
                  @node-click="handleNodeClick"
                  :default-checked-keys="numchecked"
              ></el-tree>-->
              <!-- </div> -->
            </div>
            <div class="k-table-wrapper">
              <div class="k-table-toolbar" style="margin-top:0;">
                <div>
                  <!-- <el-button :size='size' type="primary" icon="el-icon-search" @click="doSearch">查询</el-button> -->
                  <el-button
                    :size="size"
                    type="primary"
                    icon="el-icon-plus"
                    @click="handelUserAddOpen"
                    v-if="$parent.$parent.isAuthAction('home/v1.user/save')"
                  >添加人员</el-button>
                  <el-button
                    :size="size"
                    type="primary"
                    @click="handelUserResetMenu"
                    v-if="$parent.$parent.isAuthAction('home/v1.user/resetusermenu')"
                  >更新菜单权限</el-button>
                  <el-button
                    :size="size"
                    type="primary"
                    @click="handelUserResetAction"
                    v-if="$parent.$parent.isAuthAction('home/v1.user/resetuseraction')"
                  >更新功能权限</el-button>
                  <el-button
                    :size="size"
                    @click="handelCompanySet"
                    v-if="searchForm.companyId != '' && $parent.$parent.isAuthAction('home/v1.user/companySet')"
                  >设置</el-button>
                  <!-- <el-button :size='size' disabled>启用</el-button> -->
                </div>
                <!-- <el-checkbox v-model="checked" :size="size">仅展示部门直属成员</el-checkbox> -->
              </div>
              <div class="k-table-con" v-loading="loading">
                <el-table :data="tableData.data" border style="width: 100%">
                  <el-table-column fixed prop="nickname" label="用户昵称" width="180"></el-table-column>
                  <el-table-column prop="email" label="登录邮箱" width="200"></el-table-column>
                  <el-table-column prop="user_role" label="账户类型" width="100"></el-table-column>
                  <el-table-column prop="company" label="所属开户" width="200"></el-table-column>
                  <el-table-column prop="status" label="用户状态" width="100">
                    <template slot-scope="scope">
                      <el-tag :size="size" v-if="scope.row.status == 'NORMAL'" type="success">正常</el-tag>
                      <el-tag :size="size" v-if="scope.row.status == 'FROZEN'" type="danger">冻结</el-tag>
                      <el-tag :size="size" v-if="scope.row.status == 'EXPIRE'" type="warning">到期</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="create_time" label="创建时间" width="200" sortable="custom"></el-table-column>
                  <el-table-column prop="update_time" label="修改时间" width="200" sortable="custom"></el-table-column>
                  <el-table-column fixed="right" label="操作" min-width="200">
                    <template slot-scope="scope">
                      <!-- <el-button @click="handleTableAccountOpen(scope.row)" type="text" size="small">关联客户</el-button> -->
                      <el-button
                        @click="handleTableGroupsOpen(scope.row)"
                        type="text"
                        size="small"
                        v-if="$parent.$parent.isAuthAction('home/v1.user/usergroupsadd')"
                      >用户组</el-button>
                      <el-button
                        @click="handleTableStatusOpen(scope.row.id, 'FROZEN')"
                        v-if="scope.row.status == 'NORMAL' && $parent.$parent.isAuthAction('home/v1.user/userstatus')"
                        type="text"
                        :size="size"
                      >冻结</el-button>
                      <el-button
                        @click="handleTableStatusOpen(scope.row.id, 'NORMAL')"
                        v-if="scope.row.status != 'NORMAL' && $parent.$parent.isAuthAction('home/v1.user/userstatus')"
                        type="text"
                        :size="size"
                      >启用</el-button>
                      <!-- <el-button @click="handleTableStatusOpen(scope.row.id,'EXPIRE')" v-if="scope.row.status == 'NORMAL'" type="text" :size="size">到期</el-button> -->
                      <el-button
                        @click="handleTableEditOpen(scope.row)"
                        type="text"
                        :size="size"
                        v-if="$parent.$parent.isAuthAction('home/v1.user/update')"
                      >编辑</el-button>
                      <el-button
                        @click="handleTableDelete(scope.row)"
                        type="text"
                        :size="size"
                        class="c-danger"
                        v-if="$parent.$parent.isAuthAction('home/v1.user/delete')"
                      >删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  ref="pagination"
                  @current-change="handleCurrentChange"
                  :current-page="tableData.current_page | number"
                  :page-size="tableData.per_page | number"
                  layout="total, prev, pager, next, jumper"
                  :total="tableData.total | number"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" size="50%">
      <el-form
        :model="addForm"
        ref="addForm"
        :rules="rules.addForm"
        :size="size"
        label-width="110px"
      >
        <div class="drawer-header">
          <div class="header-title">
            <span>添加用户</span>
            <i class="el-icon-close k-drawer-close" @click="closeDrawerAdd"></i>
          </div>
        </div>
        <div class="drawer-content">
          <el-form-item label="用户昵称" prop="nickname">
            <el-input v-model="addForm.nickname" placeholder="请填写用户昵称"></el-input>
          </el-form-item>
          <el-form-item label="登录邮箱" prop="email">
            <el-input v-model="addForm.email" placeholder="请填写用户邮箱"></el-input>
          </el-form-item>
          <el-form-item
            label="所属公司"
            prop="company"
            v-if="info.views.user.role_text == 'USER_ROLE_SUPPER'"
          >
            <el-input v-model="addForm.company" placeholder="请填写所属公司"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="18">
              <el-form-item label="登录密码" prop="password">
                <el-input v-model="addForm.password" placeholder="请填写用户登录密码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                type="primary"
                :size="size"
                @click="makePassword('addForm')"
                style="margin-left:5px;"
              >随机密码</el-button>
            </el-col>
          </el-row>

          <el-form-item label="再次填写密码" prop="repassword">
            <el-input v-model="addForm.repassword" placeholder="请再次填写密码"></el-input>
          </el-form-item>
          <el-form-item
            label="活动区域"
            prop="user_role"
            v-if="info.views.user.role_text == 'USER_ROLE_MANAGER' || info.views.user.role_text == 'USER_ROLE_SUPPER'"
          >
            <el-select v-model="addForm.user_role" placeholder="请选择用户分类" @change="getGroupByUserId">
              <template v-if="info.views.user.role_text == 'USER_ROLE_SUPPER'">
                <el-option label="子账号" value="USER_ROLE_USER"></el-option>
                <el-option label="主账号" value="USER_ROLE_MANAGER"></el-option>
              </template>
              <template v-else-if="info.views.user.role_text == 'USER_ROLE_MANAGER'">
                <el-option label="子账号" value="USER_ROLE_USER"></el-option>
                <el-option label="主账号" value="USER_ROLE_MANAGER" :disabled="true"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="所属用户组" prop="group" v-if="addForm.user_role == 'USER_ROLE_USER'">
            <el-select v-model="addForm.group" multiple placeholder="请选择">
              <el-option
                v-for="item in groups_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账户状态" prop="status">
            <el-select v-model="addForm.status" placeholder="请选择账户状态">
              <el-option label="正常" value="NORMAL"></el-option>
              <el-option label="冻结" value="FROZEN"></el-option>
              <el-option label="到期" value="EXPIRE"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" :size="size" @click="handelUserAdd">提 交</el-button>
          <el-button :size="size" @click="closeDrawerAdd">取消</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" direction="rtl" size="50%">
      <el-form
        :model="editForm"
        ref="editForm"
        :size="size"
        :rules="rules.editForm"
        label-width="110px"
      >
        <div class="drawer-header">
          <div class="header-title">
            <span>编辑用户</span>
            <i class="el-icon-close k-drawer-close" @click="closeDrawerEdit"></i>
          </div>
        </div>
        <div class="drawer-content">
          <el-form-item label="用户昵称" prop="nickname">
            <el-input v-model="editForm.nickname" placeholder="请填写用户昵称"></el-input>
          </el-form-item>
          <el-form-item label="登录邮箱" prop="email">
            <el-input v-model="editForm.email" disabled placeholder="请填写用户邮箱"></el-input>
          </el-form-item>
          <el-form-item
            label="所属公司"
            prop="company"
            v-if="info.views.user.role_text == 'USER_ROLE_SUPPER'"
          >
            <el-input v-model="editForm.company" placeholder="请填写所属公司"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="18">
              <el-form-item label="登录密码" prop="password">
                <el-input v-model="editForm.password" placeholder="请填写用户登录密码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                type="primary"
                :size="size"
                @click="makePassword('editForm')"
                style="margin-left:5px;"
              >随机密码</el-button>
            </el-col>
          </el-row>

          <el-form-item label="再次填写密码" prop="repassword">
            <el-input v-model="editForm.repassword" placeholder="请再次填写密码"></el-input>
          </el-form-item>
          <el-form-item
            label="活动区域"
            prop="user_role"
            v-if="info.views.user.role_text == 'USER_ROLE_SUPPER' || info.views.user.role_text == 'USER_ROLE_MANAGER'"
          >
            <el-select
              v-model="editForm.user_role"
              placeholder="请选择用户分类"
              @change="getGroupByUserId"
            >
              <template v-if="info.views.user.role_text == 'USER_ROLE_SUPPER'">
                <el-option label="子账号" value="USER_ROLE_USER"></el-option>
                <el-option label="主账号" value="USER_ROLE_MANAGER"></el-option>
              </template>
              <template v-else-if="info.views.user.role_text == 'USER_ROLE_MANAGER'">
                <el-option label="子账号" value="USER_ROLE_USER"></el-option>
                <el-option label="主账号" value="USER_ROLE_MANAGER" :disabled="true"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="所属用户组"
            prop="group"
            v-if="editForm.user_role == 'USER_ROLE_USER' && (info.views.user.role_text == 'USER_ROLE_MANAGER' || info.views.user.role_text == 'USER_ROLE_SUPPER')"
          >
            <el-select v-model="addForm.group" multiple placeholder="请选择">
              <el-option
                v-for="item in groups_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账户状态" prop="status">
            <el-select v-model="editForm.status" placeholder="请选择账户状态">
              <el-option label="正常" value="NORMAL"></el-option>
              <el-option label="冻结" value="FROZEN"></el-option>
              <el-option label="到期" value="EXPIRE"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" :size="size" @click="handleTableEdit">提 交</el-button>
          <el-button :size="size" @click="closeDrawerEdit">取消</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer
      custom-class="k-drawer"
      :visible.sync="groupsFormVisiable"
      direction="rtl"
      size="50%"
    >
      <el-form :model="groupsForm" label-width="110px">
        <div class="drawer-header">
          <div class="header-title">
            <span>为用户分配用户组</span>
            <i class="el-icon-close k-drawer-close" @click="closeDrawerGroups"></i>
          </div>
        </div>
        <div class="drawer-content">
          <el-button type="text" @click="handleTableSlectAll('groupsForm')">全选</el-button>
          <el-button type="text" @click="handleTableCancelAll('groupsForm')">全不选</el-button>
          <el-button type="text" @click="handleTableSelectChange('groupsForm')">反选</el-button>
          <el-main class="k-group-check" style="height:calc(100% - 50px); padding:10px 0;">
            <el-form-item
              :label="item.name"
              prop="roles"
              :key="index"
              v-for="(item, index) in options.groups"
            >
              <el-checkbox-group v-model="groupsForm.relations">
                <el-checkbox v-for="value in item.children" :label="value.id" :key="value.id">
                  {{ value.name
                  }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-main>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" :size="size" @click="handleTableGroups">提 交</el-button>
          <el-button :size="size" @click="closeDrawerGroups">取消</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer title="为用户分配账户" :visible.sync="accountFormVisiable" direction="rtl" size="50%">
      <div class="demo-drawer__content">
        <el-row>
          <el-col :span="22" :offset="1">
            <el-form :model="accountForm" label-width="110px" labelPosition="top">
              <el-main :style="apiMainHeight">
                <el-form-item label="选择需要关联的账户（多选）:">
                  <el-select
                    style="width: 100%"
                    v-model="accountForm.value"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    @focus="changeGetInfo"
                    placeholder="请输入关键词"
                    :remote-method="remoteMethod"
                  >
                    <el-option
                      v-for="item in accountForm.relations"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-main>
              <el-form-item align="right">
                <el-button type="primary" @click="handleTableAccount">提 交</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </el-drawer>

    <el-dialog title="公司设置" :visible.sync="companySetVisiable" size="50%">
      <el-form :model="companyForm" ref="companyForm" label-width="110px" :size="size">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="结单类型 - SET" name="1">
            <el-form-item label="结单类型:">
                <el-select
                  v-model="companyForm.source_need_end_type"
                  placeholder="请选择结单类型"
                  clearable
                  reserve-keyword
                >
                <el-option
                    v-for="item in nameOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="备款账户 - SET" name="2">
            <el-form-item label="所属平台:" prop="platform_id">
              <el-select v-model="companyForm.platform_id" multiple placeholder="请选择平台" @change="changePlatform">
                <el-option
                  v-for="item in options.platform_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
              <!-- :prop="'account_arr.' + index + '.account_ids'" -->
              <el-form-item :label="domain.platform_name+'的备款账户:'" v-for="(domain, index) in companyForm.account_arr" :key="index">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder='请输入备款账户ID,英文","(逗号)隔开,例:3243432,78686787...'
                  v-model="domain.account_ids">
                </el-input>
              </el-form-item>
          </el-collapse-item>
        </el-collapse>        
        <div style="text-align: center;margin-top: 20px;" >
          <el-button @click="companySetVisiable = false" size="mini">取 消</el-button>
          <el-button type="primary" @click="submitCompanySet('companyForm')" size="mini">提 交</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['info'],
  data() {
    // 密码验证规则
    var validateAddPass = function(rule, value, callback) {
      var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,16}$/

      if (!regex.test(value)) {
        callback(
          new Error('密码长度 8 - 16 位，至少包含大写字母，小写字母和数字')
        )
      } else {
        this.$refs.addForm.validateField('repassword')
        callback()
      }
    }.bind(this)

    var validateAddRePass = function(rule, value, callback) {
      if (value !== this.addForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }.bind(this)

    // 密码验证规则
    var validateEditPass = function(rule, value, callback) {
      var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,16}$/

      if (!value) {
        callback()
      } else if (!regex.test(value)) {
        callback(
          new Error('密码长度 8 - 16 位，至少包含大写字母，小写字母和数字')
        )
      } else {
        this.$refs.editForm.validateField('repassword')
        callback()
      }
    }.bind(this)

    var validateEditRePass = function(rule, value, callback) {
      // console.log(this.editForm.password)
      // console.log(this.editForm.password)
      // if (value !== this.editForm.password) {
      if (this.editForm.repassword !== this.editForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }.bind(this)
    return {
      activeNames:'1',
      loading: false,
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      groups_options: [
        {
          label: '热门城市',
          options: [
            {
              value: 'Shanghai',
              label: '上海'
            },
            {
              value: 'Beijing',
              label: '北京'
            }
          ]
        },
        {
          label: '城市名',
          options: []
        }
      ],
      isCollapse: false,
      activeClass: 'el-icon-s-fold',
      activeName: 'first',
      slidewidth: 160,
      checked: true,
      size: 'mini',
      numchecked: '',
      status: [
        {
          value: 'NORMAL',
          label: '正常'
        },
        {
          value: 'FROZEN',
          label: '冻结'
        },
        {
          value: 'EXPIRE',
          label: '到期'
        }
      ],
      groupsFormVisiable: false,
      accountFormVisiable: false,
      addFormVisiable: false,
      editFormVisiable: false,
      companySetVisiable: false,
      companyForm: {
        source_need_end_type: '',
        platform_id:[],
        account_arr:[]
      },
      nameOptions: [
        {
          label: '手动结单',
          value: 1
        },
        {
          label: '上传结单',
          value: 2
        }
      ],
      options: {
        platform_options:[],
        groups: []
      },
      searchForm: {
        company: '',
        companyId: '',
        nickname: '',
        status: ''
      },
      resetSearch: {
        company: '',
        companyId: '',
        nickname: '',
        status: ''
      },
      addForm: {
        user_role: '',
        group: [],
        email: '',
        company: '',
        nickname: '',
        password: '',
        repassword: '',
        status: 'NORMAL'
      },
      groupsForm: {
        id: '',
        relations: []
      },
      accountForm: {
        id: '',
        value: [],
        relations: []
      },
      editForm: {
        user_role: '',
        group: [],
        email: '',
        company: '',
        nickname: '',
        password: '',
        repassword: '',
        id: '',
        status: 'NORMAL'
      },
      rules: {
        addForm: {
          nickname: [
            {
              required: true,
              message: '请填写用户昵称',
              trigger: ['change', 'blur']
            },
            {
              max: 25,
              message: '昵称长度不能超过 25 个汉字或字符',
              trigger: ['change', 'blur']
            }
          ],
          group: [
            {
              required: true,
              message: '请选择所属用户组',
              trigger: ['change']
            }
          ],
          company: [
            {
              required: function(rule, value, callback) {
                if (this.isSupper == 1) {
                  return true
                } else {
                  return false
                }
              },
              message: '请填写所属公司',
              trigger: ['change', 'blur']
            },
            {
              max: 25,
              message: '所属公司长度不能超过 25 个汉字或字符',
              trigger: ['change', 'blur']
            }
          ],
          email: [
            {
              required: true,
              message: '请填写用户邮箱',
              trigger: ['change', 'blur']
            },
            {
              type: 'email',
              message: '请填写正确的邮箱',
              trigger: ['change', 'blur']
            }
          ],
          password: [
            {
              required: true,
              message: '请填写用户登录密码，或生成随机密码',
              trigger: ['change', 'blur']
            },
            {
              validator: validateAddPass,
              trigger: ['change', 'blur']
            }
          ],
          repassword: [
            {
              required: true,
              message: '请再次填写用户登录密码，或生成随机密码',
              trigger: ['change', 'blur']
            },
            {
              validator: validateAddRePass,
              trigger: ['change', 'blur']
            }
          ],
          user_role: [
            {
              required: function(rule, value, callback) {
                if (this.isSupper == 1) {
                  return true
                } else {
                  return false
                }
              },
              message: '请选择账号类型',
              trigger: ['change', 'blur']
            }
          ]
        },
        editForm: {
          nickname: [
            {
              required: true,
              message: '请填写用户昵称',
              trigger: ['change', 'blur']
            },
            {
              max: 25,
              message: '昵称长度不能超过 25 个汉字或字符',
              trigger: ['change', 'blur']
            }
          ],
          group: [
            {
              required: true,
              message: '请选择所属用户组',
              trigger: ['change']
            }
          ],
          company: [
            {
              required: function(rule, value, callback) {
                if (this.isSupper == 1) {
                  return true
                } else {
                  return false
                }
              },
              message: '请填写所属公司',
              trigger: ['change', 'blur']
            },
            {
              max: 25,
              message: '所属公司长度不能超过 25 个汉字或字符',
              trigger: ['change', 'blur']
            }
          ],
          password: [
            {
              validator: validateEditPass,
              trigger: ['change', 'blur']
            }
          ],
          repassword: [
            {
              validator: validateEditRePass,
              trigger: ['change', 'blur']
            }
          ],
          user_role: [
            {
              required: function(rule, value, callback) {
                if (this.isSupper == 1) {
                  return true
                } else {
                  return false
                }
              },
              message: '请选择账号类型',
              trigger: ['change', 'blur']
            }
          ]
        },
      },
      tableData: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 0,
        data: []
      }
    }
  },
  computed: {
    isSupper: function() {
      return this.info.views.isSupper
    },
    tableHeight: function() {
      return window.innerHeight - 320
    },
    apiMainHeight: function() {
      var height = window.innerHeight - 200
      return {
        height: height + 'px',
        border: '1px solid #DCDFE6',
        'margin-bottom': '10px'
      }
    }
  },
  methods: {
    changePlatform:function(vals){
      var arr = []
      this.options.platform_options.forEach(function(item, index) {
        if(vals.indexOf(item.value) != -1){
          arr.push({
            'platform_id':item.value,
            'platform_name': item.label,
            'account_ids':''
          })
        }
      }.bind(this))
      this.$set(this.companyForm,'account_arr',arr)
    },
    getGroupByUserId: function(val) {
      if (val == 'USER_ROLE_USER') {
        this.$api.get('group/getGroupsByUser', {}, res => {
          if (res.code == 0) {
            this.groups_options = res.data
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'error'
            })
          }
        })
      } else {
        this.groups_options = []
      }
    },
    reset: function() {
      this.searchForm = this.resetSearch
      this.doSearch()
    },
    resetStatus: function() {
      this.searchForm.status = ''
    },
    handleSearch: function(params, page, prop, order) {
      this.loading = true
      var param = Object.assign({}, params)

      param['page'] = page ? page : 1
      param['prop'] = prop ? prop : 'id'
      param['order'] = order ? order : 'desc'

      this.$api.management.getAdvertiserList(param).then(res => {
        if (res.code == 0) {
          this.tableData = res.data
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'error'
          })
        }
        this.loading = false
      })
    },

    // 执行查询
    doSearch: function(event) {
      var query = this.searchForm
      query['_t'] = Date.parse(new Date())

      this.handleSearch(this.searchForm, 1)

      // this.$router.push({ path: this.$route.path, query: query});
    },

    // 排序
    sortChange: function(e) {
      var order
      var prop = e.prop
      if (e.order == 'ascending') {
        order = 'asc'
      } else if (e.order == 'descending') {
        order = 'desc'
      } else {
        prop = this.resetSearch.prop
        order = this.resetSearch.order
      }
      this.handleSearch(this.searchForm, 1, prop, order)
    },

    // 改变当前页 page
    handleCurrentChange: function(val) {
      this.handleSearch(this.searchForm, val)
    },

    // 全选
    handleTableSlectAll: function(form) {
      switch (form) {
        case 'groupsForm':
          var groups = []
          var item
          for (var i in this.options.groups) {
            item = this.options.groups[i]

            for (var index in item.children) {
              groups.push(item.children[index].id)
            }
          }
          this.groupsForm.relations = groups
          break
      }
    },

    // 反选
    handleTableSelectChange: function(form) {
      switch (form) {
        case 'groupsForm':
          var groups = []
          var item
          for (var i in this.options.groups) {
            item = this.options.groups[i]

            for (var index in item.children) {
              if (
                this.groupsForm.relations.indexOf(item.children[index].id) < 0
              ) {
                groups.push(item.children[index].id)
              }
            }
          }
          this.groupsForm.relations = groups
          break
      }
    },

    // 全不选
    handleTableCancelAll: function(form) {
      switch (form) {
        case 'groupsForm':
          this.groupsForm.relations = []
          break
      }
    },
    //打开滨技关联客户弹窗
    // handleTableAccountOpen: function (row) {
    //     this.loading = true;

    //     this.$myGet('{:url("home_v1_user_user_customer_get")}', {id: row.id}, function (response) {

    //         if (response.data.code === 0) {
    //             this.accountForm.value = response.data.data.value;
    //             this.accountForm.relations = response.data.data.options;
    //             this.accountFormVisiable = true;
    //             this.accountForm.id = row.id;
    //         } else {
    //             var message = '查询已关联信息失败！';

    //             if (response.data.message) {
    //                 message = response.data.message;
    //             }

    //             this.$notify({
    //                 showClose: true,
    //                 message: message,
    //                 type: 'warning'
    //             });
    //         }

    //     }, function () {
    //         this.loading = false
    //     });
    // },
    handleTableStatusOpen: function(id, status) {
      var message = ''
      if (status == 'NORMAL') {
        message = '此操作将设置该用户为【正常】状态, 是否继续?'
      } else if (status == 'FROZEN') {
        message = '此操作将设置该用户为【冻结】状态, 是否继续?'
      } else if (status == 'EXPIRE') {
        message = '此操作将设置该用户为【到期】状态, 是否继续?'
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(
          function() {
            this.loading = true
            this.$api.management
              .userStatus({
                id: id,
                status: status
              })
              .then(res => {
                var message = '用户状态修改成功！'
                var msgType = 'success'
                if (res.code == 0) {
                  var data = this.tableData.data
                  data.forEach(
                    function(item, index) {
                      if (item.id == id) {
                        this.$set(data, index, res.data)
                      }
                    }.bind(this)
                  )
                } else {
                  var message = res.message ? res.message : '用户状态修改失败！'
                  msgType = 'error'
                }
                this.loading = false
                this.$message({
                  showClose: true,
                  message: message,
                  type: msgType
                })
              })
          }.bind(this)
        )
        .catch(() => {})
    },
    // 打开编辑用户组弹窗
    handleTableGroupsOpen: function(row) {
      this.$api.management
        .getUserGroups({
          id: row.id
        })
        .then(res => {
          if (res.code === 0) {
            this.options.groups = res.data.groups
            this.groupsForm.relations = res.data.relations
            this.groupsForm.id = res.data.user.id
            this.groupsFormVisiable = true
          } else {
            var message = res.message ? res.message : '用户状态修改失败！'
            var msgType = 'error'
            this.$message({
              showClose: true,
              message: message,
              type: msgType
            })
          }
        })
    },
    //搜索需要的客户
    remoteMethod: function(query) {
      if (query !== '') {
        this.loading = true
        this.$api.management
          .getCustomer({
            query: query
          })
          .then(res => {
            if (res.code === 0) {
              this.accountForm.relations = res.data
            } else {
              this.accountForm.relations = []
            }
            this.loading = false
          })
      } else {
        this.options = []
      }
    },
    //店家下拉框获取信息
    changeGetInfo: function() {
      this.$api.management.getCustomerInt().then(res => {
        if (res.code === 0) {
          this.accountForm.relations = res.data
        } else {
          var message = res.message ? res.message : '用户状态修改失败！'
          var msgType = 'error'
          this.$message({
            showClose: true,
            message: message,
            type: msgType
          })
        }
      })
    },
    //提交关联关系
    handleTableAccount: function() {
      this.loading = true
      this.$api.management.getCustomerAdd().then(res => {
        var message = '创建关联信息成功！'
        var msgType = 'success'
        if (res.code != 0) {
          var message = res.message ? res.message : '创建关联信息失败！'
          var msgType = 'error'
        }
        this.loading = false
        this.$message({
          showClose: true,
          message: message,
          type: msgType
        })
      })
    },
    // 编辑分配用户组
    handleTableGroups: function() {
      this.loading = true
      this.$api.management.getGroupsAdd(this.groupsForm).then(res => {
        var message = '修改用户组权限信息成功！'
        var msgType = 'success'
        if (res.code == 0) {
          this.groupsFormVisiable = false
        } else {
          var message = res.message ? res.message : '创建关联信息失败！'
          var msgType = 'error'
        }
        this.loading = false
        this.$message({
          showClose: true,
          message: message,
          type: msgType
        })
      })
    },

    // 添加用户
    handelUserAddOpen: function() {
      this.addFormVisiable = true
    },

    // 添加用户
    handelUserAdd: function() {
      this.$refs['addForm'].validate(
        function(valid) {
          if (valid) {
            this.$api.management.userAdd(this.addForm).then(res => {
              var message = '添加用户成功！'
              var msgType = 'success'
              if (res.code == 0) {
                this.tableData.data.unshift(res.data)
                this.addFormVisiable = false
              } else {
                var message = res.message ? res.message : '添加用户失败！'
                var msgType = 'error'
              }
              this.$message({
                showClose: true,
                message: message,
                type: msgType
              })
            })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },

    // 生成 10 位随机密码
    makePassword: function(form) {
      var password = Math.random()
        .toString(36)
        .substr(2, 10)

      var arr = password.split('')
      var result = []
      var nochange = true
      arr.forEach(function(item, index) {
        if (!(item >= 0 && item <= 9)) {
          if (nochange) {
            item = item.toLocaleUpperCase()
            nochange = false
          } else {
            nochange = true
          }
        }

        result.push(item)
      })

      result = result.join('')

      this[form].password = result
      this[form].repassword = result
      this.$forceUpdate()
    },

    // 打开编辑用户弹窗
    handleTableEditOpen: function(row) {
      this.editFormVisiable = true
      this.loading = true
      this.$api.management
        .userEditGet({
          id: row.id
        })
        .then(res => {
          if (res.code == 0) {
            this.editForm = res.data
          } else {
            var message = res.message ? res.message : '查询用户信息失败！'
            var msgType = 'error'
            this.$message({
              showClose: true,
              message: message,
              type: msgType
            })
          }
          this.loading = false
        })
    },

    // 编辑用户
    handleTableEdit: function() {
      this.$refs['editForm'].validate(
        function(valid) {
          if (valid) {
            this.loading = true
            var params = this.editForm
            this.$api.management.userEdit(params).then(res => {
              var message = '修改用户信息成功！'
              var msgType = 'success'
              if (res.code == 0) {
                var data = this.tableData.data
                data.forEach(
                  function(item, index) {
                    if (item.id == res.data.id) {
                      this.$set(data, index, res.data)
                    }
                  }.bind(this)
                )
              } else {
                message = res.message ? res.message : '修改用户信息失败！'
                msgType = 'error'
              }
              this.editFormVisiable = false
              this.$message({
                showClose: true,
                message: message,
                type: msgType
              })
              this.loading = false
            })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },

    // 删除用户
    handleTableDelete: function(row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(
          function() {
            this.loading = true
            this.$api.management
              .userDelete({
                id: row.id
              })
              .then(res => {
                var message = '删除用户信息成功！'
                var msgType = 'success'
                if (res.code == 0) {
                  var data = this.tableData.data
                  data.forEach(
                    function(item, index) {
                      if (item.id == row.id) {
                        this.$delete(data, index)
                      }
                    }.bind(this)
                  )
                } else {
                  message = res.message ? res.message : '删除用户信息失败！'
                  msgType = 'error'
                }
                this.$message({
                  showClose: true,
                  message: message,
                  type: msgType
                })
                this.loading = false
              })
          }.bind(this)
        )
        .catch(() => {})
    },

    // 更新菜单权限
    handelUserResetMenu: function(row) {
      this.$confirm('此操作将重置菜单权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(
          function() {
            this.loading = true
            this.$api.management.updateMenus().then(res => {
              var message = '更新菜单权限信息成功！'
              var msgType = 'success'
              if (res.code != 0) {
                message = res.message ? res.message : '更新菜单权限信息失败！'
                msgType = 'error'
              }
              this.$message({
                showClose: true,
                message: message,
                type: msgType
              })
              this.loading = false
            })
          }.bind(this)
        )
        .catch(() => {})
    },
    getPlatformSelect:function(){
      this.$api.get('user/medias', {}).then(res => {
        if (res.code === 0) {
           this.options.platform_options = res.data        
        } else {
           this.$message.error(res.message)
        }
      })
    },
    //公司设置
    handelCompanySet: function() {
      this.loading = true
      this.$api
        .get('management/getCompany', {
          cid: this.searchForm.companyId
        })
        .then(res => {
          if (res.code == 0) {
            this.companyForm = res.data
            this.getPlatformSelect()
            this.companySetVisiable = true
          } else {
            var message = res.message ? res.message : '获取公司配置信息失败'
            var msgType = 'error'
            this.$message({
              showClose: true,
              message: message,
              type: msgType
            })
          }
          this.loading = false
        })
    },
    submitCompanySet: function(formName) {
      this.$refs[formName].validate((valid) => {
        if(valid){
          var param = {}
          param['cid'] = this.searchForm.companyId
          param['source_need_end_type'] = this.companyForm.source_need_end_type
          param['platform_id'] = this.companyForm.platform_id
          param['account_arr'] = this.companyForm.account_arr
          this.$api.post(
            'user/setcompany',
            param,
            function(res) {
              if (res.code == 0) {
                this.companySetVisiable = false
                this.$message({
                  showClose: true,
                  message: '设置成功',
                  type: 'success'
                })
                this.handleSearch(this.searchForm, 1)
              }
            }.bind(this)
          )
        }
      })
      
    },
    //更新功能权限信息成功！
    handelUserResetAction: function(row) {
      this.$confirm('此操作将重置功能权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(
          function() {
            this.loading = true
            this.$api.management.updateActions().then(res => {
              var message = '更新功能权限信息成功！'
              var msgType = 'success'
              if (res.code != 0) {
                message = res.message ? res.message : '更新功能权限信息失败！'
                msgType = 'error'
              }
              this.$message({
                showClose: true,
                message: message,
                type: msgType
              })
              this.loading = false
            })
          }.bind(this)
        )
        .catch(() => {})
    },

    // 生成查询参数
    makeParams: function(query) {
      var params = {}
      params['status'] = query.status ? query.status : this.searchForm.status
      params['nickname'] = query.nickname
        ? query.nickname
        : this.searchForm.nickname
      params['companyId'] = query.companyId
        ? query.companyId
        : this.searchForm.companyId
      params['company'] = query.company
        ? query.company
        : this.searchForm.company
      this.searchForm = params
      return params
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    //获取树形菜单
    getTreeData() {
      this.$api.management
        .getTreeList()
        .then(res => {
          if (res.code == 0) {
            if (res.data.length > 0) {
              this.numchecked = res.data[0].id.toString()
              this.treeData = res.data
              this.handleNodeClick(res.data[0].id)
            }
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'error'
            })
          }
        })
        .catch()
    },
    handleNodeClick(data) {
      this.treeData.forEach(
        function(item) {
          if (item.id == data) {
            this.searchForm.companyId = item.id
            this.searchForm.company = item.label
          }
        }.bind(this)
      )

      var params = this.makeParams(this.$route.query)

      this.handleSearch(params)
    },
    closeDrawerAdd: function() {
      this.addFormVisiable = false
    },
    closeDrawerEdit: function() {
      this.editFormVisiable = false
    },
    closeDrawerGroups: function() {
      this.groupsFormVisiable = false
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  mounted: function() {
    var params = this.makeParams(this.$route.query)
    this.getTreeData()
  }
}
</script>
<style lang="scss" scoped>
.k-group-check .el-form-item {
  margin-bottom: 5px;
  border-bottom: 1px solid #e8eaec;
}

.k-group-check .el-form-item:last-child {
  border-bottom: none;
}

.k-group-check .el-form-item__label {
  width: 100% !important;
  text-align: left;
}

.k-group-check .el-form-item__content {
  margin-left: 0 !important;
}

.k-page-common .k-common-con .k-member-tree {
  overflow-y: scroll;
}

.el-menu {
  border: none;

  .el-menu-item {
    height: 36px;
    line-height: 36px;
  }
}
</style>
